module.exports = __webpack_public_path__ + "img/DB_History.0ae03fd5.png";